import { render, staticRenderFns } from "./ErrorBarragan.vue?vue&type=template&id=210e21e0&scoped=true&"
import script from "./ErrorBarragan.vue?vue&type=script&lang=js&"
export * from "./ErrorBarragan.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBarragan.vue?vue&type=style&index=0&id=210e21e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e21e0",
  null
  
)

export default component.exports